import { Images } from "../../Images";
import Page from "../framework/Page";
import View from "../framework/View";
import PopupViewController from "./PopupViewController";

export default class PopupViewToggle extends View {
    /**
     * @param {string} parentId
     * @param {string} elementId 
     * @param {PopupViewController} popupViewController 
     * @param {string} popupViewId
     * @param {string} title
     */
    constructor(parentId, elementId, popupViewController, popupViewId, title) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {PopupViewController}
         */
        this.popupViewController = popupViewController;

        /**
         * @constant
         * @type {string}
         */
        this.popupViewId = popupViewId;
        /**
         * Used if we associate 2 views with the toggle.
         * @type {string}
         */
        this.secondaryPopupViewId = null;

        /**
         * @constant
         * @type {string}
         */
        this.title = title;

        /**
         * @type {HTMLElement}
         */
        this.mainElement = null;

        /**
         * @type {boolean}
         */
        this.displayedVisible = false;

    }

    /**
     * @override
     */
    initializeView() {
        // The upgrade view is dynamically created.
        const id = this.getElementId();

        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('PopupViewToggle.initializeView() No parent element found! parentId=' + this.parentId);
            return;
        }

        this.mainElement = Page.createElement('div', parent, id, 'upgrade-button-outer');

        const row1 = Page.createElement('div', this.mainElement, null, 'button-row-icon-text');  // pick-upgrade-button-row1

        ////////////////////////////////////////////////////////
        // Row:
        // [icon] [title/description] [count/cost]
        ////////////////////////////////////////////////////////

        // <img src="images/miner_icon_51x48.png"/>
        const imgElement = Page.createElement('img', row1, null, 'pick-upgrade-icon');
        imgElement.src = Images.pick;

        // Title/Description container
        const titleDescriptionContainer = Page.createElement('div', row1, null, 'pick-upgrade-title-description-container');

        const titleElement = Page.createElement('div', titleDescriptionContainer, null, 'pick-upgrade-button-title-single-row');
        titleElement.innerHTML = this.title;

        //////////////////////////////////////
        // Button Click
        //////////////////////////////////////

        const thisRef = this;
        this.mainElement.onclick = function() {
            const popupVisible = thisRef.popupViewController.isPopupVisible(thisRef.popupViewId);

            if (!popupVisible) {
                if (!thisRef.secondaryPopupViewId) {
                    thisRef.popupViewController.setPopupVisible(thisRef.popupViewId);
                }
                else {
                    thisRef.popupViewController.setDoublePopupVisible(thisRef.popupViewId, thisRef.secondaryPopupViewId);
                }
            }
            else {
                thisRef.popupViewController.hideAllPopups();
            }
        };

        super.initializeView();
    }

    /**
     * @override
     */
    updateViewContents() {

        const popupVisible = this.popupViewController.isPopupVisible(this.popupViewId);

        if (this.displayedVisible === popupVisible) {
            return;
        }

        this.displayedVisible = popupVisible;

        if (popupVisible) {
            this.mainElement.className = 'popup-toggle-button-outer-open';
        }
        else {
            this.mainElement.className = 'upgrade-button-outer';
        }
    }
}